import moment from 'moment'

/**
 *
 * @param {object} event the event object
 * @param {string} event.startTime the start time of the event
 * @description
 * This method returns a boolean indicating if the provided event is after the
 * current business start date.
 * @returns {boolean}
 */
export function isAfterBusinessDate(event) {
  const now = moment()
  const eventStart = moment(event.startTime)
  const businessStart = moment().startOf('day').add(3, 'hours')

  if (now.hours() < 3) {
    businessStart.subtract(1, 'day')
  }

  return eventStart.isAfter(businessStart)
}

/**
 *
 * @param {object} event the event object
 * @param {string} event.startTime the start time of the event
 * @description
 * This method returns a boolean indicating if the provided event is after the
 * current business end date.
 * @returns {boolean}
 */
export function isAfterEventBusinessDate(event) {
  const threshold = 24
  const now = moment()
  const startPoint = moment(event.startTime).startOf('day').add(2, 'hours').add(59, 'minutes')
  const duration = moment.duration(now.diff(startPoint))
  const hours = duration.asHours()
  const eventDatePassed = hours > threshold

  return eventDatePassed
}

/**
 *
 * @param {object} event the event object
 * @param {string} event.startTime the start time of the event
 * @description
 * This method returns a boolean indicating if the provided event is during the
 * current business date.
 * @returns {boolean}
 */
export function isDuringBusinessDate(event) {
  const now = moment()
  const eventStart = moment(event.startTime)
  const businessStart = moment().startOf('day').add(3, 'hours')
  const businessEnd = moment().startOf('day').add(1, 'day').add(3, 'hours')

  /**
   * We make this check because no events will appear if the current time
   * is between 12:00am and 2:59am.
   */
  if (now.hours() < 3) {
    businessStart.subtract(1, 'day')
    businessEnd.subtract(1, 'day')
  }

  return eventStart.isBetween(businessStart, businessEnd)
}
